import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs-compat/Observable'
import { environment } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class EmrMenuService {
    private readonly base = `${environment.core}EmrMenus`;

    constructor(private http: HttpClient) { }

    // Queries
    getFullConfig(specialtyId: number): Observable<any> {
        return this.http.get<any>(`${this.base}/config`, { params: { specialtyId } as any });
    }

    getScreenDetails(screenId: number): Observable<any> {
        return this.http.get<any>(`${this.base}/screens/${screenId}`);
    }

    // Folders
    addFolder(cmd: any) {
        return this.http.post<{ id: number; name: string }>(`${this.base}/folders`, cmd);
    }

    renameFolder(cmd: any) {
        return this.http.put<void>(`${this.base}/folders/rename`, cmd);
    }

    deleteFolder(q: any) {
        return this.http.delete<void>(`${this.base}/folders`, { params: q as any });
    }

    clearFolder(cmd: any) {
        return this.http.post<void>(`${this.base}/folders/clear`, cmd);
    }

    // Screens
    addCustomScreen(cmd: any) {
        return this.http.post<{ id: number; name: string }>(`${this.base}/screens`, cmd);
    }

    updateScreenSmartForms(cmd: any) {
        return this.http.put<void>(`${this.base}/screens/smartforms`, cmd);
    }

    // Drag & Drop ops
    moveToFolder(cmd: any) {
        return this.http.post<void>(`${this.base}/drag/move-to-folder`, cmd);
    }

    moveToRoot(cmd: any) {
        return this.http.post<void>(`${this.base}/drag/move-to-root`, cmd);
    }

    moveToPool(cmd: any) {
        return this.http.post<void>(`${this.base}/drag/move-to-pool`, cmd);
    }

    reorderFolder(cmd: any) {
        return this.http.post<void>(`${this.base}/drag/reorder-folder`, cmd);
    }

    reorderRoot(cmd: any) {
        return this.http.post<void>(`${this.base}/drag/reorder-root`, cmd);
    }

    updateScreenTabModules(payload: { screenId: number; tabModules: { id: number; name: string }[] }) {
        return this.http.put<void>(`${this.base}/screens/tabmodules`, payload);
    }
}